import script from "./CartSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CartSidebar.vue?vue&type=script&setup=true&lang=js"

import "./CartSidebar.vue?vue&type=style&index=0&id=16f2be48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f2be48"]])

export default __exports__